module.exports = __webpack_public_path__ + "img/euryops.c00328da.jpg";